export enum ActionType {
  GET_FOODTYPES = 'GET_FOODTYPES',
  GET_FOODTYPES_REJECTED = 'GET_FOODTYPES_REJECTED',
  GET_FOODTYPES_FULFILLED = 'GET_FOODTYPES_FULFILLED',
  GET_FOODTYPE_WITH_MIN_HOLDING_TIME = 'GET_FOODTYPE_WITH_MIN_HOLDING_TIME',
  GET_FOODTYPE_WITH_MIN_HOLDING_TIME_REJECTED = 'GET_FOODTYPE_WITH_MIN_HOLDING_TIME_REJECTED',
  GET_FOODTYPE_WITH_MIN_HOLDING_TIME_FULFILLED = 'GET_FOODTYPE_WITH_MIN_HOLDING_TIME_FULFILLED',
  GET_MORE_FOODTYPES = 'GET_MORE_FOODTYPES',
  GET_MORE_FOODTYPES_REJECTED = 'GET_MORE_FOODTYPES_REJECTED',
  GET_MORE_FOODTYPES_FULFILLED = 'GET_MORE_FOODTYPES_FULFILLED',
  ADD_FOODTYPES = 'ADD_FOODTYPES',
  ADD_FOODTYPES_REJECTED = 'ADD_FOODTYPES_REJECTED',
  ADD_FOODTYPES_FULFILLED = 'ADD_FOODTYPES_FULFILLED',
  EDIT_FOODTYPES = 'EDIT_FOODTYPES',
  EDIT_FOODTYPES_REJECTED = 'EDIT_FOODTYPES_REJECTED',
  EDIT_FOODTYPES_FULFILLED = 'EDIT_FOODTYPES_FULFILLED',
  DELETE_FOODTYPES = 'DELETE_FOODTYPES',
  DELETE_FOODTYPES_REJECTED = 'DELETE_FOODTYPES_REJECTED',
  DELETE_FOODTYPES_FULFILLED = 'DELETE_FOODTYPES_FULFILLED',
}

export default ActionType;
